import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import edit_partstudio_svg from '../../../assets/img/SVG_icons/Top/reference_operation/edit_reference.svg';
import { img } from '@phi/components';
import { SessionType } from '@phi/authentication/frontend';
import { edit_reference_partstudio_body } from '@frontend/scene';
import EditPartstudioTooltip from './EditPartstudioTooltip';

export const EditPartstudioIcon = edit_partstudio_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        session_type: { required: true, type: null as any as PropType<Set<SessionType>> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Edit imported PartStudio references';
        },

        disabled() {
            return !this.state.loaded
                || (
                    this.state.framework !== 'onshape'
                    && !this.session_type.has('onshape')
                )
                || !this.state.showing_reference_partstudio_models;
        },

        active() {
            return this.state.showing_reference_partstudio_models
                && this.state.editing_reference_partstudio;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                edit_reference_partstudio_body();
        },
    },

    render() {
        return h(BarButton, {
            id: 'edit-partstudio-button',
            tippy: 'top',
            onClick: this.onClick,
            active: this.active,
            selected: this.state.tut_stage === 13,
            disabled: this.disabled,
            help: 'edit_partstudio_reference_model',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(edit_partstudio_svg, this.alt),
            tooltip: EditPartstudioTooltip
        });
    },
});
